/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EquipmentCategoryResponse
 */
export interface EquipmentCategoryResponse {
    /**
     * 
     * @type {number}
     * @memberof EquipmentCategoryResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof EquipmentCategoryResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EquipmentCategoryResponse
     */
    description?: string;
}

/**
 * Check if a given object implements the EquipmentCategoryResponse interface.
 */
export function instanceOfEquipmentCategoryResponse(value: object): value is EquipmentCategoryResponse {
    return true;
}

export function EquipmentCategoryResponseFromJSON(json: any): EquipmentCategoryResponse {
    return EquipmentCategoryResponseFromJSONTyped(json, false);
}

export function EquipmentCategoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentCategoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function EquipmentCategoryResponseToJSON(json: any): EquipmentCategoryResponse {
    return EquipmentCategoryResponseToJSONTyped(json, false);
}

export function EquipmentCategoryResponseToJSONTyped(value?: EquipmentCategoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

